import { useQuery } from '@tanstack/react-query'
import { getDearProducts } from '@api/getDearProducts'
import type {
  GetDearProductsResponse,
} from '@api/getDearProducts'

export const useGetDearProducts = (productCategories: string[], currency: string = 'usd') =>
  useQuery<GetDearProductsResponse, Error>({
    queryKey: ['dear-products', productCategories, currency],
    queryFn: () => getDearProducts({ productCategories, currency }),
    enabled: productCategories.length > 0,
  })
